import { createBigDecimal } from '@0xtorch/big-decimal'
import { z } from 'zod'

export const closedPnlSchema = z.object({
  /** Symbol name, e.g. "OPPERP" */
  symbol: z.string(),
  /** Order ID, e.g. "7440ac4b-ff08-4565-af9a-57e790702a55" */
  orderId: z.string(),
  /** Buy, Sell */
  side: z.union([z.literal('Buy'), z.literal('Sell')]),
  /** Order qty, e.g. "3" */
  qty: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** Order price, e.g. "2.07" */
  orderPrice: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** Order type. Market,Limit,UNKNOWN */
  orderType: z.union([
    z.literal('Market'),
    z.literal('Limit'),
    z.literal('UNKNOWN'),
  ]),
  /** Exec type, Trade, BustTrade, SessionSettlePnL, Settle, MovePosition */
  execType: z.union([
    z.literal('Trade'),
    z.literal('BustTrade'),
    z.literal('SessionSettlePnL'),
    z.literal('Settle'),
    z.literal('MovePosition'),
  ]),
  /** Closed size, e.g. "3" */
  closedSize: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** Cumulated Position value, e.g. "6.471" */
  cumEntryValue: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** Average entry price, e.g. "2.157" */
  avgEntryPrice: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** Cumulated exit position value, e.g. "6.5055" */
  cumExitValue: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** Average exit price, e.g. "2.1685" */
  avgExitPrice: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** Closed PnL, e.g. "0.02704777" */
  closedPnl: z
    .string()
    .regex(/^-?\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** The number of fills in a single order, e.g. "1" */
  fillCount: z.string(),
  /** leverage, e.g. "10" */
  leverage: z.string(),
  /** The created time (ms), e.g. "1734582115396" */
  createdTime: z
    .string()
    .regex(/^\d+$/)
    .transform((v) => Number.parseInt(v, 10)),
  /** The updated time (ms), e.g. "1734582115399" */
  updatedTime: z
    .string()
    .regex(/^\d+$/)
    .transform((v) => Number.parseInt(v, 10)),
})

export type ClosedPnl = z.infer<typeof closedPnlSchema>

export const resultSchema = z.object({
  nextPageCursor: z.string().nullable().optional(),
  category: z.string(),
  list: z.array(closedPnlSchema),
})
